module.exports = __webpack_public_path__ + "img/1.bdf697cd.png";